const extraServices = {
  header: {
    btnCreate: 'Create',
  },

  toast: {
    error: {
      badResponse: '[Extra Service] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Extra Service] created successfully',
      },
      edit: {},
      delete: {
        default: '[Extra Service] deleted successfully',
      },
    },
  },

  deleteModal: {
    header: 'Delete Extra Services',
    body: 'You are about to delete {{num}} extra services.',
  },

  table: {
    filters: {
      profileType: 'Profile Type'
    },
    headers: {
      name: 'Extra Service',
      profileType: 'Profile Type',
      basePrice: 'Base',
      extraPrice: 'Each Extra',
      baseUpTo: 'Base Up To',
      surcharge: 'Surcharge',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
  },

  create: {
    successToast: {
      message: 'Success! Extra Service Created',
    },
    errorToast: {
      message: 'Error occurred. Could Not Create Extra Service',
    },
  },

  edit: {
    successToast: {
      message: 'Success! Extra Service Updated',
    },
    errorToast: {
      message: 'Error occurred. Could Not Update Extra Service',
    },
  },

  forms: {
    header: {
      createExtraService: {
        title: 'Create',
      },

      updateExtraService: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      details: {
        header: 'Details',
        fields: {
          name: 'Extra Service',
          profileType: 'Profile Type',
          description: 'Description',
          profileTypeOptions: {
            retail: 'Retail',
            individual: 'Individual',
            wholesale: 'Wholesale',
            corporate: 'Corporate',
            website: 'Website',
            hotel: 'Hotel',
            thirdParty: '3rd Party',
            tourOperator: 'Tour Operator',
            receiptiveOperator: 'Receiptive Operator',
          },
        },
      },
      settings: {
        header: 'Settings',
        fields: {
          basePrice: 'Base',
          extraPrice: 'Each Extra',
          baseUpTo: 'Base Up To',
          surcharge: 'Surcharge',
        },
      },
    },
  },
};

export default extraServices;
